import debug from 'bows';
import MostRead from '../_most-read';

const log = debug('subscribe');

class Home {
	constructor(opts) {
		this.opts = opts;

		this.mostRead = Array.from( document.querySelectorAll( '.mr' ) ).map( ( node ) => new MostRead( node ) );

		log(this);
	}
}

export default function( opts = {} ) {
	return new Home(opts);
}
